import { XMark, Tag } from '@raydiant/raydial/components/Icons';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import * as paths from '../../routes/paths';
import analytics from '../../clients/analyticsClient';

const BlackFridayBanner = () => {
  const history = useHistory();
  const [isOpen, setIsOpen] = useState(true);

  const handleViewButtonClick = () => {
    // segment tracking
    analytics.trackPromoBannerCTAClicked({
      promoType: 'black_friday',
      location: 'top_banner',
    });
    history.push(paths.plans('pro'));
  };

  if (!isOpen) return null;

  return (
    <div className="bg-[#343437] text-white p-2 flex items-center justify-center relative">
      <Tag size={16} />
      <span className="text-lg font-semibold px-2">
        Limited-Time Offer: Black Friday + Cyber Monday Deal
      </span>
      <button
        className="bg-red-800 rounded-3xl flex justify-center items-center"
        onClick={handleViewButtonClick}
        aria-label="View Black Friday promotion plans"
      >
        <span className="text-sm font-bold px-2 py-1">Get it now</span>
      </button>
      <button
        className="absolute right-2.5"
        aria-label="Close Black Friday banner"
        onClick={() => setIsOpen(false)}
      >
        <XMark />
      </button>
    </div>
  );
};

export default BlackFridayBanner;
